<div class="commercial-operational-notes-toolbar">
  <div class="commercial-operational-notes-filters">
    <div class="commercial-operational-notes-date-field">
      <label
        for="commercial-operational-notes-start-date"
        class="commercial-operational-notes-field-label"
      >
        {{ 'CRM.LABEL.START_DATE' | translate }}:
      </label>
      <div class="commercial-operational-notes-date-input">
        <p-datepicker
          inputId="commercial-operational-notes-start-date"
          [showButtonBar]="true"
          [ngModel]="startDate"
          (ngModelChange)="onDateChange($event, true)"
          (onTodayClick)="resetDateRangeToToday()"
          dateFormat="yy-mm-dd"
          [required]="true"
          [invalid]="!startDate"
          [autofocus]="false"
        />
        @if (!startDate) {
          <small class="commercial-operational-notes-date-error" role="alert">
            {{
              'COMMERCIAL_SERVICES.VALIDATION.START_DATE_REQUIRED' | translate
            }}
          </small>
        }
      </div>
    </div>
    <div class="commercial-operational-notes-date-field">
      <label
        for="commercial-operational-notes-end-date"
        class="commercial-operational-notes-field-label"
      >
        {{ 'CRM.LABEL.END_DATE' | translate }}:
      </label>
      <div class="commercial-operational-notes-date-input">
        <p-datepicker
          inputId="commercial-operational-notes-end-date"
          [showButtonBar]="true"
          [ngModel]="endDate"
          (ngModelChange)="onDateChange($event, false)"
          (onTodayClick)="resetDateRangeToToday()"
          dateFormat="yy-mm-dd"
          [minDate]="startDate"
          [required]="true"
          [invalid]="!endDate"
          [autofocus]="false"
        />
        @if (!endDate) {
          <small class="commercial-operational-notes-date-error" role="alert">
            {{ 'COMMERCIAL_SERVICES.VALIDATION.END_DATE_REQUIRED' | translate }}
          </small>
        }
      </div>
    </div>

    <app-business-unit-filter
      (selectedBusinessUnitsChanged)="refresh(true)"
      #buFilter
    />
  </div>
  <div class="commercial-operational-notes-actions">
    <button
      pButton
      pRipple
      type="button"
      label="{{ 'COMMON.LABEL.BUTTONS.CLEAR' | translate }}"
      icon="fa fa-fw fa-eraser"
      class="p-button-success"
      (click)="clearScreen()"
    ></button>
    <button
      pButton
      pRipple
      type="button"
      icon="fa fa-fw fa-refresh"
      class="p-button-success"
      [attr.aria-label]="'COMMON.LABEL.BUTTONS.REFRESH' | translate"
      [disabled]="!dateRange"
      (click)="refresh()"
    ></button>
  </div>
</div>

<app-general-grid
  [values]="elements"
  [columns]="columns"
  [totalRecords]="totalRecords"
  [filterable]="true"
  [screenName]="screenName"
  [rows]="rows"
  [lazy]="true"
  (lazyLoad)="lazyLoad($event)"
  [loading]="loading"
  [includeExportCSV]="false"
  scrollHeight="calc(100vh - 30vh)"
  [usePaginator]="true"
  [rowsPerPageOptions]="[50, 100, 200]"
  [whiteSpaceStyle]="'pre-wrap'"
  #grid
/>
<p-toast />
